// @flow

export const GET_FLIGHTS: string = 'get_flights';
export const GET_FLIGHTS_SUCCESS: string = 'get_fligts_success';
export const GET_FLIGHTS_FAIL: string = 'get_fligts_fail';
export const DELETE_FLIGHT: string = 'delete_fligts';
export const DELETE_FLIGHT_SUCCESS: string = 'delete_fligts_success';
export const DELETE_FLIGHT_FAIL: string = 'delete_fligts_fail';
export const EDIT_FLIGHT: string = 'edit_flight';
export const EDIT_FLIGHT_SUCCESS: string = 'edit_flight_success';
export const EDIT_FLIGHT_FAIL: string = 'edit_flight_fail';
export const ADD_FLIGHT: string = 'add_flight';
export const ADD_FLIGHT_SUCCESS: string = 'add_flight_success';
export const ADD_FLIGHT_FAIL: string = 'add_flight_fail';
export const CLEAR_FLIGHT_MANAGER_ERROR: string = "clear_flight_manager_error";
export const SELECT_FLIGHT: string = "set_chosen_flight";
export const SET_CHOSEN_FLIGHT_BY_ID: string = "set_chosen_flight_by_id";
export const START_FLIGHT: string = "start_flight";
export const START_FLIGHT_SUCCESS: string = "start_flight_success";
export const START_FLIGHT_FAIL: string = "start_flight_fail";
export const FINISH_FLIGHT: string = "finish_flight";
export const FINISH_FLIGHT_SUCCESS: string = "finish_flight_success";
export const FINISH_FLIGHT_FAIL: string = "finish_flight_fail";
export const TOGGLE_ATTRIBUTES: string = "toggle_attributes";
export const GET_PRODUCTS: string = 'get_products';
export const GET_PRODUCTS_SUCCESS: string = 'get_products_success';
export const GET_PRODUCTS_FAIL: string = 'get_products_fail';
export const GET_TIME_ZONES: string = 'get_time_zones';
export const GET_TIME_ZONES_SUCCESS: string = 'get_time_zones_success';
export const GET_TIME_ZONES_FAIL: string = 'get_time_zones_fail';
export const SET_FLIGHT_GEOMETRY_TYPE: string = 'set_flight_geometry_type';


// WEBPACK FOOTER //
// ./src/types/flightManager.jsx